import { Modal } from 'ant-design-vue';
import { reactive, ref } from 'vue';
import { apiRoutes } from '../infraestructure/apiRoutes';
import { buildQueryParameters, get, post, softDelete, update } from '../infraestructure/repository/generic.repository';
import useBusinessUnit from "./useBusinessUnit";
const roles = [
  { key: 'SUPER ADMIN', value: 'Super Administrador' },
  { key: 'OPERATIVE ADMIN', value: 'Administrador Operativo' },
  { key: 'DRIVER', value: 'Conductor' },
]

const useUser = () => {

  const {
    selectBusinessUnits,
    getBusinessUnitsNoPaginate,
  } = useBusinessUnit()

  // ****************************************************************
  // ****************************************************************
  // VARIABLES INITIALIZATION

  // Paginator constants
  let paginatorTotalItems = ref(0)
  let paginatorTotalPages = ref(0)
  let paginatorCurrentPage = ref(0)

  const searchText = ref('')
  const visible = ref(false)

  const formId = ref('')
  const changePassword = ref(false)
  let form = reactive({
    name: '',
    email: '',
    password: '',
    role: '',
    businessUnit: '',
    truckCode: '',
    status: true,
  })
  let formLoad = ref(false)

  const rules = {
    name: [{ required: true, message: 'El nombre de usuario es obligatorio' }],
    email: [
      { required: true, message: 'El correo electrónico es obligatorio' },
      { type: 'email', message: 'Formato de correo inválido' },
      {
      validator: (_, v) => {
          const ok = /^[a-z0-9._%+-]+@holcim\.com$/i.test(String(v || '').trim());
          return ok ? Promise.resolve() : Promise.reject('El correo debe pertenecer al dominio holcim.com');
        },
        trigger: ['change', 'blur'],
      },
    ],
    password: [
      { required: true, message: 'La contraseña es obligatoria' },
      { min: 8, message: 'La contraseña debe tener al menos 8 caracteres' },
      { max: 50, message: 'La contraseña no debe exceder 50 caracteres' },
      {
        pattern: /(?:(?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/,
        message: 'La contraseña debe tener mayúscula, minúscula y un número',
      },
    ],
    role: [{ required: true, message: 'El rol es obligatorio' }],
    businessUnit: [{ required: true, message: 'La unidad de negocio es obligatoria' }],
    truckCode: [{ required: true, message: 'El código de económico es obligatorio' }],
  };


  // ERROR VARIABLES
  let errorHandler = reactive({
    errorDescription: {
      errors: [],
    },
    errorNumber: 0,
  })
  const ruleForm = ref(null)

  const users = ref([])
  const selectRoles = ref(roles)
  const tableLoading = ref(false)
  // VARIABLES INITIALIZATION
  // ****************************************************************
  // ****************************************************************

  // ****************************************************************
  // ****************************************************************
  // MODAL FUNCTIONS
  const openModal = async (data = null) => {
    tableLoading.value = true
    visible.value = true
    await getBusinessUnitsNoPaginate()
    if (formId.value !== '' && data) {
      const {
        name,
        email,
        img,
        role,
        businessUnit,
        google,
        status,
        truckCode,
      } = data

      form.name = name
      form.email = email
      form.password = ''
      form.img = img
      form.role = role
      form.businessUnit = businessUnit?.id ?? undefined
      form.google = google
      form.truckCode = truckCode
      form.status = status
      form.changePassword = false
      changePassword.value = false
    } else {
      changePassword.value = true;
      form.changePassword = true;
    }
    tableLoading.value = false
  }
  const closeModal = () => {
    visible.value = false
    reinitializeForm()
  }
  const reinitializeForm = () => {
    formId.value = ''

    form.name = ''
    form.email = ''
    form.password = ''
    form.img = ''
    form.role = ''
    form.businessUnit = ''
    form.truckCode = ''
    form.google = true
    form.status = true
    form.changePassword = false;
    changePassword.value = false;

    errorHandler.errorDescription.errors = []
    errorHandler.errorNumber = 0
  }
  // MODAL FUNCTIONS
  // ****************************************************************
  // ****************************************************************

  // ****************************************************************
  // ****************************************************************
  // EVENTS FUNCTIONS
  const eventOpenModal = (data) => {
    const { id } = data
    formId.value = id
    openModal(data)
  }

  const eventSoftDelete = (data) => {
    Modal.confirm({
      title: '¿Está seguro de eliminar este registro?',
      content: 'Está operación será irreversible, elija con precaución.',
      okText: 'Si, eliminar',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        tableLoading.value = true

        const { id } = data
        formId.value = id
        deleteRecord()
      },
      onCancel() {
      },
    })
  }
  // EVENTS FUNCTIONS
  // ****************************************************************
  // ****************************************************************

  const onChangePaginator = async (current) => {
    await getUsers(10, (current - 1))
  }

  const getUsers = async (limit = 10, page = 0) => {
    tableLoading.value = true

    const path = `${apiRoutes.user}${buildQueryParameters(searchText, limit, page)}`
    const response = await get(path)
    const { items, total, totalPages, currentPage } = response.data

    users.value = items
    paginatorTotalItems.value = total
    paginatorTotalPages.value = totalPages
    paginatorCurrentPage.value = currentPage

    tableLoading.value = false
  }
  getUsers(10, 0)

  const submit = async () => {
    formLoad.value = true
    const path = apiRoutes.user

    // Additional manual validations for password field
    if ((formId.value === '' || changePassword.value) && !form.password) {
      errorHandler.errorDescription.errors = ['La contraseña es obligatoria'];
      errorHandler.errorNumber = 400;
      formLoad.value = false;
      return;
    }
    // Maximum and Minimum length
    if ((formId.value === '' || changePassword.value) && form.password && form.password.length < 8) {
      errorHandler.errorDescription.errors = ['La contraseña debe tener al menos 8 caracteres'];
      errorHandler.errorNumber = 400;
      formLoad.value = false;
      return;
    }
    if ((formId.value === '' || changePassword.value) && form.password && form.password.length > 50) {
      errorHandler.errorDescription.errors = ['La contraseña no debe exceder 50 caracteres'];
      errorHandler.errorNumber = 400;
      formLoad.value = false;
      return;
    }

    // If there is a password, validate the pattern as well (same as `rules`)
    if (
      (formId.value === '' || changePassword.value) &&
      !/(?:(?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(form.password)
    ) {
      errorHandler.errorDescription.errors = ['La contraseña debe tener mayúscula, minúscula y un número'];
      errorHandler.errorNumber = 400;
      formLoad.value = false;
      return;
    }

    if (formId.value !== '') {

      // UPDATE
      const updatePayload = {
        name: form.name,
        email: form.email,
        role: form.role,
        businessUnit: form.businessUnit,
        truckCode: form.truckCode,
        status: form.status,
        ...(changePassword.value ? { password: form.password } : {}),
      };

      await update(path, formId.value, updatePayload)
        .then(() => {
          Modal.success({ title: '¡El registro se ha actualizado exitosamente!' });
          closeModal();
          formLoad.value = false;
        })
        .catch((error) => {
          if (error?.message && !error?.response) {
            const msgs = [String(error.message)].filter(Boolean)
            errorHandler.errorDescription.errors = msgs.length ? msgs : ['Ha ocurrido un error desconocido']
            errorHandler.errorNumber = Number.isFinite(error.status) ? error.status : 0
            formLoad.value = false
            return
          }

          const data = error?.response?.data
          let msgs = []

          if (Array.isArray(data?.message)) {
            msgs = data.message.map(m => String(m)).filter(Boolean)
          } else if (typeof data?.message === 'string') {
            msgs = [data.message].filter(Boolean)
          } else if (Array.isArray(data)) {
            msgs = data
              .flatMap(item => {
                if (typeof item === 'string') return [item]
                if (item?.message && typeof item.message === 'string') return [item.message]
                if (item?.constraints && typeof item.constraints === 'object') {
                  return Object.values(item.constraints).map(v => String(v))
                }
                return []
              })
              .filter(Boolean)
          } else if (data?.errors && Array.isArray(data.errors)) {
            msgs = data.errors
              .flatMap(err => {
                if (typeof err === 'string') return [err]
                if (err?.message) return [String(err.message)]
                if (err?.constraints) return Object.values(err.constraints).map(v => String(v))
                return []
              })
              .filter(Boolean)
          }

          if (!msgs.length) {
            const status = error?.response?.status || data?.statusCode
            const text = (typeof data === 'string') ? data : ''
            msgs = [
              (text || error?.message || 'Ha ocurrido un error al guardar. Verifica tu conexión o intenta más tarde.'),
            ].filter(Boolean)
            errorHandler.errorNumber = Number.isFinite(status) ? status : 0
          } else {
            errorHandler.errorNumber = data?.statusCode || error?.response?.status || 0
          }

          errorHandler.errorDescription.errors = msgs
          formLoad.value = false
        })


    } else {

      // CREATE
      const payload = {
        name: form.name,
        email: form.email,
        password: form.password,           // Required for creation
        role: form.role,
        businessUnit: form.businessUnit,
        truckCode: form.truckCode,
        status: form.status,
      };

      await post(path + '/register', payload)
        .then(() => {
          Modal.success({ title: '¡El registro se ha almacenado exitosamente!' });
          closeModal();
          formLoad.value = false;
        })
        .catch((error) => {
          if (error?.message && !error?.response) {
            const msgs = [String(error.message)].filter(Boolean)
            errorHandler.errorDescription.errors = msgs.length ? msgs : ['Ha ocurrido un error desconocido']
            errorHandler.errorNumber = Number.isFinite(error.status) ? error.status : 0
            formLoad.value = false
            return
          }

          const data = error?.response?.data
          let msgs = []

          if (Array.isArray(data?.message)) {
            msgs = data.message.map(m => String(m)).filter(Boolean)
          } else if (typeof data?.message === 'string') {
            msgs = [data.message].filter(Boolean)
          } else if (Array.isArray(data)) {
            msgs = data
              .flatMap(item => {
                if (typeof item === 'string') return [item]
                if (item?.message && typeof item.message === 'string') return [item.message]
                if (item?.constraints && typeof item.constraints === 'object') {
                  return Object.values(item.constraints).map(v => String(v))
                }
                return []
              })
              .filter(Boolean)
          } else if (data?.errors && Array.isArray(data.errors)) {
            msgs = data.errors
              .flatMap(err => {
                if (typeof err === 'string') return [err]
                if (err?.message) return [String(err.message)]
                if (err?.constraints) return Object.values(err.constraints).map(v => String(v))
                return []
              })
              .filter(Boolean)
          }

          if (!msgs.length) {
            const status = error?.response?.status || data?.statusCode
            const text = (typeof data === 'string') ? data : ''
            msgs = [
              (text || error?.message || 'Ha ocurrido un error al guardar. Verifica tu conexión o intenta más tarde.'),
            ].filter(Boolean)
            errorHandler.errorNumber = Number.isFinite(status) ? status : 0
          } else {
            errorHandler.errorNumber = data?.statusCode || error?.response?.status || 0
          }

          errorHandler.errorDescription.errors = msgs
          formLoad.value = false
        })

    }

    await getUsers(10, 0)
  }

  const deleteRecord = async () => {

    const path = apiRoutes.user
    const response = await softDelete(path, formId.value)
    if (response) {
      formId.value = ''
      await getUsers(10, 0)
    }

  }

  const handleChange = (selectedItem) => {
    form.businessUnit = selectedItem
  }

  const handleRoleChange = (selectedItem) => {
    form.role = selectedItem
  }

  const handleChangePassword = (value) => {
    changePassword.value = value;
    form.changePassword = value;
  }

  return {
    selectBusinessUnits,

    searchText,
    visible,
    formId,
    form,
    formLoad,
    rules,
    users,
    selectRoles,
    tableLoading,
    errorHandler,
    ruleForm,

    paginatorTotalItems,
    paginatorTotalPages,
    paginatorCurrentPage,
    onChangePaginator,

    openModal,
    closeModal,
    getUsers,
    submit,
    deleteRecord,

    eventOpenModal,
    eventSoftDelete,
    handleChange,
    handleRoleChange,

    handleChangePassword,
  }
}

export default useUser

